module.exports = __webpack_public_path__ + "static/media/logo-sdurdd.24ae90f0.svg";